// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._7gssQXTwfzkAjuhGCkVaPw\\=\\={align-items:center;display:flex;justify-content:center;margin-top:15px}", "",{"version":3,"sources":["webpack://./resources/sass/webview/components/EditProfile.module.scss"],"names":[],"mappings":"AAAA,6BAGI,kBAAA,CADA,YAAA,CAEA,sBAAA,CAHA,eAIJ","sourcesContent":[".deleteAccount {\n    margin-top: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteAccount": "_7gssQXTwfzkAjuhGCkVaPw=="
};
export default ___CSS_LOADER_EXPORT___;
